import React, { Component } from 'react'
import Modal from 'react-modal'
import { connect } from 'react-redux';

import {
    addDocumento, getAgrupador
} from '../../actions'

class ModalFormDocumento extends Component {
    constructor(props){
        super(props)

        this.state = {
            modalIsOpen: true,
            file: undefined,
            agrupador: ''
        }

        this.openModal = this.openModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.addDocumento = this.addDocumento.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
    }

    componentDidMount(){
        this.props.getAgrupador()
    }

    openModal() {
        //this.setState({modalIsOpen: true});
        this.props.openModal()
    }

    closeModal() {
        //console.log(this.props)
        this.props.closeModal()
        //this.setState({modalIsOpen: false});
    }
    
    changeValue(input){
        let label = document.getElementById('label-file')
        label.innerText = input.files.length > 0 ? input.files[0].name : ''
        this.setState({ file: input.files[0] })
    }

    addDocumento(event){
        event.preventDefault()
        const { file, agrupador, numero } = this.state
       // return console.log(agrupador)
        this.props.addDocumento(file,{ agrupador, numero }, async add => {
            if(add) {
                try{
                    await this.setState({ agrupador: '', file: undefined, numero: ''})
                    document.querySelector('#label-file').textContent = 'Escolha'
                    document.querySelector('form#formDoc select').value = ''

                    Array.from(document.querySelectorAll('form#formDoc input')).map( input => input.value = '')
                    
                } catch (error) {
                    console.log(error)
                }
                document.querySelector('#modalFormDocumento .close').click()
            }
        })

    }

    handleInputChange(event){
        this.setState({
            [event.target.name]: event.target.value 
        })
    }
    
    render(){
        const { load_doc, error_doc, tags } = this.props.documentos
        const boxTags = tags || []
        return(
            <div className="modal fade" id="modalFormDocumento" tabIndex="-1" role="dialog" aria-labelledby="modalSendDoc"
            aria-hidden="true">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <form id="formDoc" onSubmit ={this.addDocumento}>
                            <div className="modal-header">
                                <h5 className="modal-title" id="modalSendDoc">Adicionar documento</h5>
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={this.closeModal}>
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>

                            <h6 className="text-center pt-3">Selecione um arquivo em PDF para ser assinado</h6>

                            <div className="modal-body">
                                <div className="custom-file" >
                                    <input type="file" className="custom-file-input" id="customFile" style={{cursor:'pointer'}} onChange={(event) => this.changeValue(event.target)} required/>
                                    <label className="custom-file-label" id="label-file">Selecione um arquivo</label>
                                </div>
                            </div>

                            <div className="modal-body">
                                <div className="form-group">
                                    <label  className="">Número do contrato</label>
                                    <input name="numero" type="text"  className="form-control" placeholder="Número do contrato" required onChange={this.handleInputChange} />
                                </div>

                                <div className="form-group">
                                    <label  className="">Grupo</label>
                                    <select name='agrupador' className="form-control form-control-sm" onChange={this.handleInputChange} value={this.state.agrupador}>
                                        <option value={''} key={'optionAll'}>nenhum</option>
                                        {boxTags.map( (tag,index) => (
                                            <option value={tag.titulo} key={'option'+index}>{tag.titulo}</option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                            
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" data-dismiss="modal" onClick={this.closeModal}>Cancelar</button>
                                <button type="submit" className="btn btn-primary"  disabled={load_doc}>
                                    {load_doc ? <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>:null}
                                {load_doc ? 'Aguarde...' : 'Adicionar'} 
                                </button>
                            </div>
                        </form>

                        {error_doc != ''
                            ?<div className="alert alert-danger" role="alert" style={{marginTop:'1%'}}>
                                {error_doc.originalMessage}
                            </div>
                            :null
                        }
                    </div>
                </div>
                <style>
                {
                    `
                    #customFile.custom-file-input:lang(en)~.custom-file-label::after {
                        content: "Selecionar";
                        background-color: #007bff;
                        color: white;
                    }
                    `
                }
                </style>
            </div>
        )
    }
}

const mapStateToProps = ({ documentos }) => {
    return {
        documentos
    }
}

export default connect(mapStateToProps, {
    addDocumento, getAgrupador
})(ModalFormDocumento);

const customStyles = {
    main: {
        paddingLeft: '2%',
        paddingRight: '2%'
    },
    modal:{
        width:'50%',
        // height: '50%',
        left:'35%',
        top: '80px',
    }
}